module.exports = __webpack_public_path__ + "img/madera022.0744da46.jpg";